import './Photo.scss';
import { Link } from 'react-router-dom';
import { isToday } from '../after';
import { Icon } from './RSVP';
import arrow from '../img/svg/arrow-right-svgrepo-com.svg';
import { useI18n } from '../i18n/i18n';

export function Meta() {
    const t = useI18n();
    return <>
        <section className={"meta dark quarter" + (isToday() ? ' today' : '')}>
            <h2>{t.meta.welcome}</h2>
            <p style={{ textAlign: 'center' }}>{t.meta.instruction}</p>
            <div className="cta">
                <Link className="cta-link google-form-link" to="/rsvp">
                    <span>{t.meta.rsvp}</span>
                    <Icon src={arrow} alt="Google Forms" classNames={['small']} />
                </Link>
            </div>
        </section>
        <div className="dev">
            <span style={{ padding: '4px', opacity: 0.5 }}>{t.meta.by}</span>
        </div>
    </>;
}
